<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('/calibration/calibrationranges/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('samples.range_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
        </div>
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          />
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
          >
            <template slot="addColumns">
              <table-column-badges
                prop="businesses_names"
                :label="$t('common_words.associated_companies2')"
                fromData="businesses_names"
                :isObject="false"
                :minWidth="150"
              />
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="100"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <export-tables
          :pdf="{
            filename: `${$t('calibration.calibration_ranges')}.pdf`,
            route: '',
            showPDFButton: false,
          }"
          :xls="{
            filename: `${$t('calibration.calibration_ranges')}.xlsx`,
            route: 'calibration/calibrationranges/excel',
          }"
        />
        <br />
      </card>
    </div>
    <el-dialog
      width="60%"
      :title="$t('common_words.record_selected_threepoints')"
      :visible.sync="modals.read"
      :close-on-click-modal="false"
    >
      <div class="card" v-if="rowData">
        <div class="card-body">
          <table class="table">
            <tbody>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('common_words.starting_date_f') }}:</strong>
                  </h6>
                  {{ rowData.start_date }}
                </td>
                <td>
                  <h6>
                    <strong>{{ $t('calibration.hands_type') }}:</strong>
                  </h6>
                  {{
                    rowData.calibration_type
                      ? rowData.calibration_type.name
                      : 'N/A'
                  }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td colspan="2">
                  <h6 class="custom-margin-h6-table">
                    <strong
                      >{{ $t('common_words.associated_companies') }}:</strong
                    >
                  </h6>
                  <span
                    v-for="(business, index) in rowData.businesses_names"
                    :key="index"
                  >
                    <el-tag type="info" class="mr-1">{{ business }}</el-tag>
                  </span>
                  <el-tag
                    type="warning"
                    v-if="
                      !rowData.businesses_names ||
                      rowData.businesses_names.length === 0
                    "
                  >
                    {{ $t('common_words.no_associated_companies') }}
                  </el-tag>
                </td>
              </tr>
              <tr class="shadow-sm">
                <td colspan="2">
                  <h6>
                    <strong
                      >{{
                        $t('calibration.detail_of_calibration_range')
                      }}:</strong
                    >
                  </h6>
                  <el-table
                    :data="rowData.calibration_range_details"
                    stripe
                    border
                  >
                    <el-table-column
                      prop="name"
                      :label="$t('samples.range_name')"
                    ></el-table-column>
                    <el-table-column :label="$t('common_words.limit_lower')">
                      <template slot-scope="scope">
                        {{ scope.row.min_operator }} {{ scope.row.min_value }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('common_words.limit_upper')">
                      <template slot-scope="scope">
                        <span v-if="parseFloat(scope.row.max_value) > 0">
                          {{ scope.row.max_operator }} {{ scope.row.max_value }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('common_words.color')"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <div
                          v-if="scope.row.color"
                          :style="{
                            backgroundColor: scope.row.color,
                            color: scope.row.text_color,
                            fontWeight: 'bold',
                            padding: '5px 10px',
                            borderRadius: '5px',
                            textAlign: 'center',
                          }"
                        >
                          {{ $t('common_words.text_color') }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer footer-date-at">
          <p class="text-muted">
            <small
              >{{ $t('common_words.created_on') }}:
              {{ rowData.created_at }}</small
            >
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import mixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import configTable from './calibration-range-table';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';
import moment from 'moment';

export default {
  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      rangeCalibrationForm: {
        businesses_id: [],
      },
      pagination: {},
      tableColumns: [],
      rowData: null,
      modals: {
        read: false,
        create: false,
      },
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    mixinDatePicker,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleView(index, row) {
      this.rowData = Object.assign({}, row);

      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss a');

      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.rangeCalibrationForm = Object.assign({}, row);

      row.url_path_form = '/calibration/calibrationranges/edit';
      sessionStorage.setItem(
        'editForm',
        JSON.stringify(this.rangeCalibrationForm)
      );
      this.$router.push({ path: '/calibration/calibrationranges/edit' });
    },

    handleDelete(index, row) {
      this.rangeCalibrationForm = row;
      SweetAlert.disable(
        `${i18n.t('common_words.record_deactivate')} ${
          this.rangeCalibrationForm.start_date
        }`
      ).then((result) => {
        if (result.value) this.deleteRange();
      });
    },

    handleActivate(index, row) {
      this.rangeCalibrationForm = row;
      SweetAlert.default(
        `${i18n.t('common_words.record_activate')} "${
          this.rangeCalibrationForm.start_date
        }"?`,
        null,
        i18n.t('sweet_alert.station.accept'),
        1
      ).then((result) => {
        if (result.value) this.activateRecord();
      });
    },

    activateRecord() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.rangeCalibrationForm.route =
          'calibration/calibrationranges/activate';
        Axios.updateMaster(this.rangeCalibrationForm)
          .then((response) => {
            this.modifyTable(1, this.rangeCalibrationForm.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deleteRange() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.rangeCalibrationForm.route = 'calibration/calibrationranges';
        Axios.destroyMaster(this.rangeCalibrationForm)
          .then((response) => {
            this.modifyTable(1, this.rangeCalibrationForm.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('calibration/calibrationranges')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('calibration');
  },

  destroyed() {
    this.deselectedItemOnMenu('calibration');
  },
};
</script>
<style>
.width-label {
  width: 500px !important;
}
</style>
